import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue'
import BasicStatus from '@/components/DataTable/BasicStatus';

const columnHelper = createColumnHelper();


function createColumn(accessor, header, size, cell = ({ getValue }) => getValue()) {
  return columnHelper.accessor(accessor, {
    header,
    cell,
    size,
  });
}


export function getUploadHistoryColumns(type) {
  let columnType = 'Yüklenen';
  switch (type) {
    case 'CREATE':
      columnType = 'Yüklenen';
      break;
    case 'UPDATE':
      columnType = 'Güncellenen';
      break;
    case 'DELETE':
      columnType = 'Silinen';
      break;
  }
  return [
    createColumn('taskSourceFile', 'Dosya', 300),
    createColumn('uploadDate', 'Yükleme Tarihi', 176),
    createColumn('totalCount', 'Yüklenen Ürün', 176),
    createColumn('successfulCount', `Başarılı ${columnType} Ürün`, 176),
    createColumn(
      'taskStatus',
      'Durum',
      176,
      ({ getValue }) =>
        h(BasicStatus, {
          type: getValue(),
        }),
    ),
    createColumn('failedCount', 'Hatalı Ürün', 106),
  ];
}

export function getDownloadHistoryColumns() {
  return [
    createColumn('fileName', 'Şablon', 300),
    createColumn('createdDate', 'Oluşturma Tarihi', 176),
    createColumn(
      'jobStatus',
      'Durum',
      176,
      ({ getValue }) =>
        h(BasicStatus, {
          type: getValue(),
        }),
    ),
    createColumn('jobStatus', 'İşlem', 106),
  ];
}

export function getRejectReasonColumns() {
  return [
    createColumn('productCode','Ürün Kodu',246),
    createColumn('message', 'Hata Mesajı', 978),
  ];
}
